export const TEAM_OPEN_CREATE_MODAL = "TEAM_OPEN_CREATE_MODAL";
export const TEAM_DETAIL_ARCHIVE = "TEAM_DETAIL_ARCHIVE";
export const TEAM_DETAIL_EDIT = "TEAM_DETAIL_EDIT";
export const TEAM_EDIT_SAVE = "TEAM_EDIT_SAVE";
export const TEAM_EDIT_CANCEL = "TEAM_EDIT_CANCEL";
